import { Api as BackendApi } from '../codegen/backend/Api';
import { Revision as CsApi } from '../codegen/cs/Revision';
import { Tokens as PublicApi } from '../codegen/public_api/Tokens';
import { Api as TdmApi } from '../codegen/tdm/Api';
import { createClient, createClientWithCustomFetch } from './factory';
export const BackendClient = createClientWithCustomFetch(BackendApi);
export const BackendNoAuthClient = createClient(BackendApi);
export const CSClient = createClient(CsApi);
export const TDMClient = createClient(TdmApi);
export const PublicApiClient = createClientWithCustomFetch(PublicApi);
export { GraphQLClient, gql } from './graphql';
//# sourceMappingURL=index.js.map